export async function downloadFileFromUrl(
	fileUrl: string,
	fileName: string
): Promise<void> {
	const response = await fetch(fileUrl);
	const blob = await response.blob();
	const objectUrl = URL.createObjectURL(blob);
	const anchor = document.createElement("a");
	anchor.href = objectUrl;
	anchor.download = fileName;
	anchor.rel = "noopener noreferrer";
	anchor.style.display = "none";
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
	URL.revokeObjectURL(objectUrl);
}
